<template>
    <div class="xiangmu">
        <div class="leaderBox" v-if="showOrhide"> 
            <div class="newtext">新手指引</div>
            <img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../assets/images/cpgl.png" class="steps step1" v-if="status==1">
            <img src="../../assets/images/cpgl1.png" class="steps step2" v-if="status==2">
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
<!--        <div class="h-crumbOut">-->
<!--            <div class="h-crumbs">-->
<!--                <el-breadcrumb separator="|">-->
<!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--                    <el-breadcrumb-item>交货期维护</el-breadcrumb-item>-->
<!--                </el-breadcrumb>-->
<!--            </div>-->
<!--        </div>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30">
            <div class="h-formBox">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">
                        
                        <el-form-item label="产品编号">
                            <el-input v-model="q.productCode" placeholder=""></el-input>
                        </el-form-item>

                        <el-form-item label="审批状态">
                            <el-select v-model="q.checkStatus" placeholder="请选择">
                                <el-option v-for="item in codeList" :key="item.value"
                                    :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="审批开始时间">
                            <el-date-picker
                                style="width: 100%;"
                                v-model="q.startDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="开始日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="审批结束时间">
                            <el-date-picker
                                style="width: 100%;"
                                v-model="q.endDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        </div>

                    
                </el-form>
                <div class="l-screenBox">
                    <!-- <div class="l-screen" @click="collapseChange">
                        <img :src="isScreen?closeScreen:drawScreen" alt="">
                        <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                    </div> -->
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                        <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" style="width:1.9rem;"
                            @click="toNew">新增标准交货天数
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-table h-mrt30" v-if="clickActive==1">
            <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData2"
                    style="width: 100%"
                    :border="true"
                    max-height="440">
                <el-table-column
                        type="selection"
                        width="45"
                        :label="all"
                >
                </el-table-column>
                <el-table-column
                        fixed
                        type="index"
                        label="#"
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="productCode"
                        label="产品编号"
                        width="130"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                                <el-table-column
                        prop="productModel"
                        label="产品型号"
                        min-width="130"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="levelCodeName"
                        label="产品大类"
                        width="130"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="商品状态"
                        width="100"
                        :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                    <span v-if="scope.row.status==1">有效</span>
                    <span v-if="scope.row.status==0">无效</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="deliveryDay"
                        label="有效天数"
                        width="80"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="checkStatus"
                        label="审批状态"
                        width="100"
                        :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.checkStatus == 10">暂存</span>
                        <span v-if="scope.row.checkStatus==20">审批中</span>
                        <span v-if="scope.row.checkStatus==30">已驳回</span>
                        <span v-if="scope.row.checkStatus==40">审核通过</span>
                    </template>
                </el-table-column>
                
                <el-table-column
                        prop="remarks"
                        label="备注"
                        width="140"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="expriationDate"
                        label="失效日期"
                        width="140"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="checkDate"
                        label="审批日期"
                        width="140"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                        label="操作"
                        fixed="right"
                        width="180"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <!-- v-if="scope.row.statusflag!= 10" -->
                            <el-button
                                    v-if="scope.row.checkStatus == 30"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn" @click="todetail(scope.row)">
                                重新提交
                            </el-button>
                            
                            <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn" @click="xiugai(scope.row)">
                                修改
                            </el-button>
                            <!-- v-if="_user.usercode == scope.row.cucode && scope.row.status == 20" -->
                            <el-button size="small" class="h-tableLink h-btn"
                                        @click="sapCHOrder(scope.row)">删除
                                </el-button>
                            
                            <el-button
                                    v-if="(scope.row.zhuangtaidaima==1||scope.row.zhuangtaidaima==0)&&scope.row.zhuangtaidaima!=null&&scope.row.zhuangtaidaima!=''"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="chakanjindu(scope.row)">跟踪
                            </el-button>
                        </div>
                        <!-- <div class="l-operationBox">
                            <span class="l-operationlist br-operation-look" v-if="scope.row.statusflag!=0" title="查看" @click="todetail(scope.row)"></span>
                            <span class="l-operationlist br-operation-xg" v-else title="修改" @click="xiugai(scope.row)"></span>
                            <span class="l-operationlist br-operation-spgz" v-if="(scope.row.zhuangtaidaima==1||scope.row.zhuangtaidaima==0)&&scope.row.zhuangtaidaima!=null&&scope.row.zhuangtaidaima!=''" title="跟踪审批" @click="chakanjindu(scope.row)"></span>
                        </div> -->

                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" :disabled="this.multipleSelection.length==0" style="margin-left:-20px;" @click="verifySendAll">发起审核</el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="outexcel">批量导出
                    </el-button>
                    <el-button
                            class="h-btn h-formBtn h-bgblueQ"
                            icon="h-el-icon h-el-icon-export"
                            @click="uploaddownexcelflagbtn">
                        批量导入
                    </el-button>
                    <uploaddownexcel
                            :visible.sync="uploaddownexcelflag"
                            v-if="uploaddownexcelflag"
                            clsname="deliveryDayImportExcel"
                            :startrow="2"
                            @callback="uploadExcelFilecallback"/>
                </div>

                <!-- <div class="h-pagination2">
                    <pagination :page="q" @query="query"/>
                </div>


                <br/><br/><br/> -->
                <div class="h-pagination2">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="currentPage"
                            :page-sizes="[10,50,100,500]"
                            :page-size="q.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="q.total"
                    ></el-pagination>
                </div>
                <!--					<div class="h-pagination2">-->
                <!--						<span class="h-pagiLabel">显示数量:</span>-->
                <!--						<el-pagination-->
                <!--						  @size-change="handleSizeChange"-->
                <!--						  @current-change="handleCurrentChange"-->
                <!--						  :current-page="4"-->
                <!--						  :page-sizes="[10, 20, 30, 40]"-->
                <!--						  :page-size="10"-->
                <!--						  layout="sizes, prev, pager, next,jumper"-->
                <!--						  :total="400">-->
                <!--						</el-pagination>-->
                <!--					</div>-->
            </div>
        </div>

        <!--  -->
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        <!-- 新增 -->
        <el-dialog :close-on-click-modal="false" class="new-dialog"  :visible.sync="chehuidialogFormVisible">
            <!-- dialogImg -->
            <div class="h-dialogImg ">
                <h3>{{this.title}}</h3>
            </div>
            <el-form v-if="addForm" :model="addDelivery" label-width="100px" :rules="rules" :inline="true" size="mini" class="addDeliveryForm">
                
                <el-form-item label="产品编号"  label-width="100" prop="productCode">
                    <el-input @blur="searchNum()" v-model="addDelivery.productCode"  placeholder="请输入产品编号"></el-input>
                </el-form-item>
                <!-- <el-form-item>
                    <el-button size="mini" type="primary" @click="searchNum" >查询</el-button>
                </el-form-item> -->
                <el-form-item label="产品型号" label-width="100" prop="productModel">
                    <el-input disabled v-model="addDelivery.productModel" placeholder="请输入产品型号" ></el-input>
                </el-form-item>
                <el-form-item label="大类编号" label-width="100" prop="levelCode">
                    <el-input disabled v-model="addDelivery.levelCode"  placeholder="请输入大类编号"></el-input>
                </el-form-item>
                <el-form-item label="大类名称" label-width="100" prop="levelCodeName">
                    <!-- <brselectlazy category="product_level" :v="q.levelCode" v-model="q.levelCode"
                            :clearable="true"
                            style="width:100%"/> -->
                    <el-input disabled v-model="addDelivery.levelCodeName" placeholder="请输入大类名称" ></el-input>
                </el-form-item>
                <el-form-item label="期望交货天数" label-width="100" prop="deliveryDay">
                    <el-input v-model="addDelivery.deliveryDay" placeholder="请输入天数" ></el-input>
                </el-form-item>

            </el-form>
            <el-form v-if="updateForm" :model="updateDelivery" label-width="100px" :rules="rules" :inline="true" size="mini" class="addDeliveryForm">
                <el-form-item label="id" label-width="100" prop="id" style="display:none">
                    <el-input v-model="updateDelivery.id" placeholder="id" ></el-input>
                </el-form-item>
                <el-form-item label="产品名称" label-width="100" prop="productModel">
                    <el-input disabled v-model="updateDelivery.productModel" placeholder="请输入产品名称" ></el-input>
                </el-form-item>
                <el-form-item label="产品编号" label-width="100" prop="productCode">
                    <el-input disabled v-model="updateDelivery.productCode"  placeholder="请输入产品编号"></el-input>
                </el-form-item>
                <el-form-item label="大类编号" label-width="100" prop="levelCode">
                    <el-input disabled v-model="updateDelivery.levelCode"  placeholder="请输入大类编号"></el-input>
                </el-form-item>
                <el-form-item label="大类名称" label-width="100" prop="levelCodeName">
                    <el-input disabled v-model="updateDelivery.levelCodeName" placeholder="请输入大类名称" ></el-input>
                </el-form-item>
                <el-form-item label="期望交货天数" label-width="100" prop="deliveryDay">
                    <el-input v-model="updateDelivery.deliveryDay" placeholder="请输入天数" ></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="chehui" v-if="addDeliveryBtn">确 定</el-button>
                <el-button class="h-btn h-bBtn" @click="updateInfo" v-if="updateDeliveryBtn">修 改</el-button>
                <el-button class="h-btn h-bBtn" @click="resubmit" v-if="resubmitBtn">重新提交</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'

    export default {
        name: "productManage",
        data() {
            return {
                //批量导入
                uploaddownexcelflag: false,
                // 展开折叠筛选
                isScreen:false,
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                // 新手引导页
                showOrhide:false, 
                status:1,
                checked:true,
                toshow:"productManage",

                instid:'',
                //imgflag3: true,
                showhistory:false,
                codeList:[{ value: 10,
                    label: '暂存'},
                    { value: 20,
                    label: '审批中'},
                    { value: 30,
                    label: '已驳回'},
                    { value: 40,
                    label: '审核通过'}],
                chanpinzhuangtai: [{
                    value: 1,
                    label: '虚拟物料'
                }, {
                    value: 0,
                    label: '真实物料'
                }],

                jindu: [{
                    value: 1,
                    label: '提交'
                }, {
                    value: 0,
                    label: '暂存'
                }],

                q: {
                    materialCode:null,
                    checkStatus:null,
                    startDate:null,
                    endDate:null,
                    levelCode:null,

                    //hid: null,
                    // fictitious: null,
                    // materialGroupCode: null,
                    // materialDescrition: null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                currentPage:1,
                addDelivery:{
                    productModel:null,
                    productCode:null,
                    levelCode:null,
                    levelCodeName:null,
                    deliveryDay:null,
                },
                addDeliveryBtn:false,
                addForm:false,
                updateDelivery:{
                    id:'',
                    productModel:null,
                    productCode:null,
                    levelCode:null,
                    levelCodeName:null,
                    deliveryDay:null,
                },
                updateDeliveryBtn:false,
                updateForm:false,
                resubmitBtn:false,

                wuliaozu: [],
                chanpindalei: [],
                //弹出层 
                chehuidialogFormVisible: false,
                //title
                title:'',
                //表单
                all: '全部',
                // formInline: {
                //     dalei: '',
                //     status: '',
                //     group: '',
                //     type: '',
                // },
                //表格
                multipleSelection: [],
                tableData2: [],
                clickActive: 1,
                rules: {
                    productModel: [
                        { required: true, message: '请输入产品名称', trigger: 'blur' },
                    ],
                    productCode: [
                        { required: true, message: '请输入产品编号', trigger: 'blur' },
                    ],
                    levelCode: [
                        { required: true, message: '请输入大类编号', trigger: 'blur' },
                    ],
                    levelCodeName: [
                        { required: true, message: '请输入大类名称', trigger: 'blur' },
                    ],
                    deliveryDay: [
                        { required: true, message: '请输入期望交货天数', trigger: 'blur' },
                    ],
                }
            }
        },

        //加载页面默认执行
        created() {
            this.showzhezhao()
            //默认首次交互
            this.gettableels();
        },

        //监听
        watch: {},
        methods: {
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            showzhezhao(){
                ss.salesList.toshow(this.toshow).then(rd => {
                    console.log(rd)
                    if(rd == false){
                        this.showOrhide = false;
                    }else{
                        this.showOrhide = true;
                    }
                })
            },
            chakanjindu(q){
                var material = {
                    mdmMaterialInfoCopy:{
                        id:q.xuniwuliao,
                    }
                }
                console.log(material,'material')
                ss.chanpin.chaxunwuliao(material).then(rd => {
                    console.log(rd,'rd')
                    this.instid = rd.obj.instid;
                    this.showhistory = true;
                })
            },
            //查询单号
            searchNum(){
                //
                var num = this.addDelivery.productCode
                ss.chanpin.searchNumApi(num).then(res =>{
                    console.log(res.obj)
                    if(res.f == true){

                        //this.addDelivery.productCode = materialCode
                        //this.addDelivery.levelCodeName = res.obj.levelName //大类名称
                        //this.addDelivery.levelCode ='' //产品大类
                        this.addDelivery ={
                            productCode: res.obj.materialCode,
                            levelCodeName :res.obj.levelName,
                            levelCode:res.obj.levelCode,
                            productModel :res.obj.materialDescrition
                        }

                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            resetData(){
                console.log("重置")
                

                this.q = {
                    materialCode:null,
                    checkStatus:null,
                    startDate:null,
                    endDate:null,
                    levelCode:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                }
                
                    
                // this.q.hid = null;
                // this.q.status = null;
                // this.q.materialGroupCode = null;
                // this.q.materialDescrition = null;
                // this.q.materialCode = null;
                // this.q.fictitious = null;
                // this.q.pageSize = 10;
                // this.q.pageNo = 1;
            },
             // 分页
            handleCurrentChange: function (currentPage) {
                console.log(currentPage)
                this.q.pageNo = currentPage; //点击第几页
                this.query()
            },

            // 每页信息数量更改
            handleSizeChange(val) {
                console.log(val)
                this.currentPage = 1
                this.q.pageSize = val
                this.query()
            },

            // handleCurrentChange() {

            // },
            // handleSizeChange() {

            // },
            //删除
            sapCHOrder(row){
                this.$msg.confirm("确认删除选中的交货期信息?", () => {
                        var id = row.id
                        console.log(id)
                        var ids = {
                            id:id
                        }
                        ss.chanpin.deleteDeliveryday(ids).then(res =>{
                            console.log(res)
                            if(res.f == true){
                                this.$message({
                                    message: res.msg,
                                    type: 'success'
                                });
                                this.query()
                            }else{
                                this.$message.error(res.msg);
                            }
                        })
                    });
            },
            //创建新物料
            toNew() {
                //this.$router.push({path: '/chanp/productCreate'});
                this.title ="新增交货日期"
                this.chehuidialogFormVisible = true;
                this.addDeliveryBtn = true;
                this.addDelivery = {}
                this.addForm =true;
                this.updateDeliveryBtn = false;
                this.updateForm= false;
                this.resubmitBtn = false
            },
            cancel(){
                this.chehuidialogFormVisible = false;
            },
            //新增
            chehui(){
                ss.chanpin.insertDeliveryday(this.addDelivery).then(res =>{
                    console.log(res)
                    if(res.f == true){
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        this.chehuidialogFormVisible = false;
                        this.addDelivery ={}
                        this.query()
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },

            //详情
            todetail(q) {
                this.title ="重新提交交货日期"
                this.chehuidialogFormVisible = true;
                //this.$router.push({path: '/chanp/productDetail', query: q});
                this.addDeliveryBtn =false;
                this.addForm =false;
                this.updateDeliveryBtn =false;
                this.updateForm = true;
                this.updateDelivery = q
                this.resubmitBtn = true;
            },
            //重新提交
            resubmit(){
                var data = this.updateDelivery
                //var data = this.multipleSelection
                //console.log(data)
                ss.chanpin.startProcess(data).then(res =>{
                    console.log(res)
                    if(res.f == true){
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        this.chehuidialogFormVisible = false;
                        this.addDelivery ={}
                        this.query()
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            //发起审核
            verifySendAll(){
                //
                var data = this.multipleSelection
                ss.chanpin.verifySendAllApi(data).then(res =>{
                    console.log(res)
                    if(res.f == true){
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        this.query()
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },

            //查询翻页
            query() {
                // this.q.ids = [];
                // this.q.rowids = [];
                ss.chanpin.selectDeliveryday(this.q).then(rd => {
                    console.log('看看走没走查询',rd.records)
                        this.tableData2 = rd.records,
                        this.q.total = rd.total;
                    // for (var t in rd.records) {
                    //     console.log(rd.records[t]);
                    //     var ousa = ((rd.records[t].fictitious == null|| rd.records[t].fictitious=='')&&rd.records[t].fictitious!=0) ? (rd.records[t].rowId != null && rd.records[t].rowId != '') ? 'mdm产品' : '' : rd.records[t].fictitious == 0 ? '真实产品' : '虚拟产品';
                    //     console.log(ousa, '啥')
                    //     if (rd.records[t].rowId != null) {
                    //         ousa = 'mdm产品';
                    //     }
                    //     var ss = {
                    //         levelCodeName: rd.records[t].levelname||'',//产品大类
                    //         materialGroupCode: rd.records[t].materialGroupCode,//物料组
                    //         materialDescrition: rd.records[t].materialDescrition,//物料型号
                    //         oemType: rd.records[t].oemType||'',//业务类型  SH或者HK。SH为上海OEM，HK为香港OEM    ****只有从我们这里保存的产品才有****
                    //         fictitious: ousa,//状态  0 真实产品   1 虚拟产品
                    //         hid: rd.records[t].hid,
                    //         rowId: rd.records[t].rowId,
                    //         zhuangtaidaima: rd.records[t].fictitious,
                    //         materialCode: rd.records[t].materialCode,//含虚拟物料的表的编码
                    //         rowId: rd.records[t].rowId,//mdm取数的表的主键
                    //         status: rd.records[t].status == 0 ? '失效' : rd.records[t].status == 1 ? '有效' : '',//mdm取数的表的主键
                    //         xuniwuliao: rd.records[t].xuniwuliao,//虚拟物料编码
                    //         statusflag: rd.records[t].status,//暂存提交的fiag
                    //         groupname: rd.records[t].groupname,//物料组名
                    //     }
                    //     this.tableData2.push(ss);
                    //}
                })
            },
            //加载配置项
            gettableels() {
                this.query();
            },
            handleFilter() {
                this.q.pageNo = 1;
                this.query();
            },
            handleSelectionChange(val) {
                console.log(val)
                this.multipleSelection = val;
            },
            //导表
            outexcel() {
                ss.chanpin.downloadExcelProduct(this.q);
            },
            //修改内容
            xiugai(q){
                this.title ="修改交货日期"
                this.chehuidialogFormVisible = true;
                this.updateDelivery = q
                this.addDeliveryBtn = false;
                this.addForm =false;
                this.updateDeliveryBtn = true;
                this.updateForm= true;
                this.resubmitBtn = false;

                //this.$router.push({path: '/chanp/productCreate', query: q});
            },
            //提交修改
            updateInfo(){
                var data = this.updateDelivery
                console.log(data)
                ss.chanpin.updateDeliveryday(data).then(res =>{
                    console.log(res)
                    if(res.f == true){
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        this.chehuidialogFormVisible = false
                        this.query()
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            // //点击查看详情
            // chakan(item) {
            //
            // 	console.log('行', item)
            //
            // 	this.$router.push({ path:'/jingpin/detail' , query: {id: item.id}});
            //
            // }
            closeIt(){
                this.showOrhide = false;
                if(this.checked){
                    sessionStorage.productManage= '3';
                    ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                }
            },
            nextStep(i){
                if(this.status ==1){
                    this.status = 2;
                }else if(this.status ==2){
                    if(this.checked){
                        ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    }else{
                        ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    }
                }
            },
            addcompd(){
                if (this.multipleSelection.length == 0) {
                    this.$msg.msge("请至少选择一条数据！");
                } else {
                    // this.$router.push({name:'/chanp/comparisonDetails',params:{datalist:this.multipleSelection}})
                    var proli = [];
                    for (var i = 0; i < this.multipleSelection.length; i++) {
                        if (this.multipleSelection[i].fictitious != "mdm产品") {
                            this.$msg.msge("请选择mdm产品！");
                            return false;
                        }
                        proli.push(this.multipleSelection[i].materialCode);
                    }
                    JSON.stringify(proli)
                    sessionStorage.setItem('duibiproli',proli);
                    this.$router.push('/chanp/comparisonDetails');
                }
            }
        },
        mounted() {
        },
        components: {
            uploaddownexcel,
        },
    }
    </script>
    <style scoped>
    .xiangmu > .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 3rem !important;
    }
    /deep/ .el-dialog__header{
        padding: 0
    }
    /deep/.el-dialog {
        border-radius: 0.1rem;
        width: 7.89rem;
    }
    /deep/ .el-dialog__body{
        padding: 0;
    }
    /deep/ .el-dialog__header{
        background: #2785E7
    }
    /deep/ .el-dialog__headerbtn .el-dialog__close{
        height: 0.56rem;
        width: 0.56rem;
        line-height: 0.56rem;
        text-align: center;
        background-color: #fff;
        color: #015ba0;
        border-radius: 100%;
        font-size: 0.34rem;
    }
    .h-dialogImg {
        height: 1.62rem;
        background: url(/img/h-dialogImg.471fa846.png) center no-repeat;
        background-size: 7.89rem;
        padding-left: 4.02rem;
    }
    .h-dialogImg h3{
        text-align: left;
        padding:.6rem 0 0 0;
        font-size: 0.3rem;
        color: #fff;
        font-weight: normal;
        letter-spacing: 0.02rem;
    }
    .addDeliveryForm{
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .addDeliveryForm /deep/.el-form-item__label {
        width: 84px;
        font-size: 0.18rem;
        color: #4a4a4a;
        line-height: 0.28rem;
        vertical-align: top;
        padding-right: 5px;
        letter-spacing: 0;
        display:inline-block;
        text-align: right;
    }
    .addDeliveryForm /deep/.el-form-item__content .el-input__inner {
        border-radius: 0;
        background: transparent;
        color: #868686;
        border: 0;
        border-bottom: 1px solid #dedede;
        height: 0.29rem;
        line-height: 0.28rem;
        padding-left: 0.15rem;
    }

    </style>
    <style scoped lang="scss">

    .bottomTip{
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }
    .newtext{
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top:0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow:1px 1px 4px #2785E7;
        z-index: 2;
    }
    .leaderBox{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;
        .leaderbg{
            width: 100%;
            height: 100%;
        }
        .steps{
            position: absolute;
            z-index: 1;
        }
        .step1{
            top:2.3rem;
            left: 8.25rem;
            width: 2.1rem;
            height: 1.8rem;
        }
        .step2{
            top: 3.05rem;
            right: 1.1rem;
            width: 2.8rem;
            height: 1.9rem;
        }
        .step3{
            top: 4.2rem;
            left: 2.7rem;
            width: 13.5rem;
            height: 2rem;
        }
        .step4{
            top: 6.2rem;
            left:11rem;
            width: 2rem;
            height: 1.5rem;
        }
        .stepbtn{
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0,0,0,0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.65rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }
        .closeIt{
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
    </style>
